import React from 'react';
import {useListSAMTasksQuery} from "../../apis/samApi";
import TaskTable from "../../components/tables/TaskTable";

const SAMTaskTable = () => {
    const {data: tasks, isFetching} = useListSAMTasksQuery();
    
    return (
       
        <TaskTable tasks={tasks}
            loading={isFetching}
            showCompleteDefaultStatus={false}
            showPrivacyColumn={true}
            editTaskEndpoint={`/company-admin/shared-action-meetings/edit-task`}
            newSubTaskEndpoint={`/company-admin/shared-action-meetings/edit-task/new/parent-task`}
        />

    )
}

export default SAMTaskTable;
